import { FaHiking, FaCampground, FaMountain, FaTools } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaHiking />, // Hiking icon
        title: 'Hiking Trips',
        description: 'Experience the great outdoors with our guided hikes.',
    },
    {
        id: 2,
        icon: <FaCampground />, // Camping icon
        title: 'Camping Tours',
        description: 'Experience the wilderness with our expert-led tours.',
    },
    {
        id: 3,
        icon: <FaMountain />, // Trekking icon
        title: 'Trekking',
        description: 'Embark on multi-day treks through stunning landscapes.',
    },
    {
        id: 4,
        icon: <FaTools />, // Tools icon
        title: 'Outdoor Skills',
        description: 'Learn essential skills for safe and enjoyable outdoor activities.',
    },
];

export default features;